import { render, staticRenderFns } from "./SimTab.vue?vue&type=template&id=6a922364&scoped=true"
import script from "./SimTab.vue?vue&type=script&lang=js"
export * from "./SimTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a922364",
  null
  
)

export default component.exports